module.exports = __webpack_public_path__ + "img/8.24d59a07.png";